import React from "react";

const TONE_STYLES = {
  success: {
    color: "#4caf50",
    background: "rgba(76, 175, 80, 0.12)",
    border: "rgba(76, 175, 80, 0.35)",
  },
  warning: {
    color: "#e8b84b",
    background: "rgba(232, 184, 75, 0.12)",
    border: "rgba(232, 184, 75, 0.35)",
  },
  danger: {
    color: "#f27059",
    background: "rgba(242, 112, 89, 0.12)",
    border: "rgba(242, 112, 89, 0.35)",
  },
  muted: {
    color: "#c3c8cc",
    background: "rgba(255, 255, 255, 0.06)",
    border: "rgba(255, 255, 255, 0.12)",
  },
};

const PolicyDeadlineBadge = ({ info, title }) => {
  if (!info) {
    return (
      <span
        title={title}
        style={{
          display: "inline-flex",
          alignItems: "center",
          borderRadius: 999,
          padding: "3px 8px",
          fontSize: 11,
          fontWeight: 800,
          lineHeight: 1,
          color: TONE_STYLES.muted.color,
          background: TONE_STYLES.muted.background,
          border: `1px solid ${TONE_STYLES.muted.border}`,
          whiteSpace: "nowrap",
        }}
      >
        —
      </span>
    );
  }

  const tone = TONE_STYLES[info.tone] || TONE_STYLES.muted;

  return (
    <span
      title={title}
      style={{
        display: "inline-flex",
        alignItems: "center",
        borderRadius: 999,
        padding: "3px 8px",
        fontSize: 11,
        fontWeight: 800,
        lineHeight: 1,
        color: tone.color,
        background: tone.background,
        border: `1px solid ${tone.border}`,
        whiteSpace: "nowrap",
      }}
    >
      {info.label}
    </span>
  );
};

export default PolicyDeadlineBadge;
